import { EvaluationSubmissionResult } from 'generated/graphql';
import PrivateIcon from 'packages/kakapo-ui-kit/assets/icons/PrivateIcon';
import { TI, Trans } from 'react-i18next';
import styled from 'styled-components';

const PrivateAnswer = styled.div`
	display: flex;
	flex-direction: row;
	gap: 10px;
	color: ${(props) => props.theme.colors.slateBlue};

	svg {
		opacity: 0.8;
	}
`;

export default function PrivateAnswerDisplay({ result }: { result: EvaluationSubmissionResult }) {
	const {
		user: { firstName },
	} = result;

	return (
		<PrivateAnswer>
			<PrivateIcon color="#6C7680" />
			<p>
				<Trans i18nKey="evaluation.privateAnswer">
					Het bericht van <strong>{{ firstName } as TI}</strong> is zichtbaar als jullie beiden
					jullie antwoord hebben gedeeld.
				</Trans>
			</p>
		</PrivateAnswer>
	);
}
